"use client";

// packages/eden-form-parts/src/components/Input.jsx
import { useContext, forwardRef } from "react";
import styled from "styled-components";
import { sharedInputCss } from '../utils/sharedCss.js';
import {
  ValidityStateContext,
  SmallContext,
  IdContext,
  DescribedByContext,
  TypeContext,
  DisabledContext
} from '../utils/context.js';
import { AppearanceContext } from "@churchofjesuschrist/eden-appearance";
import { jsx } from "react/jsx-runtime";
var InternalUseOnlyInput = styled.input`
  ${sharedInputCss};

  margin: 0;

  &[type] {
    appearance: none;
    box-sizing: border-box;
  }
`;
var InputComponent = ({
  "aria-describedby": ariaDescribedBy,
  id,
  small,
  type = "text",
  disabled,
  ...props
}, ref) => {
  const validityStateContext = useContext(ValidityStateContext);
  const smallContext = useContext(SmallContext);
  const idContext = useContext(IdContext);
  const describedByContext = useContext(DescribedByContext);
  const curAppearanceContext = useContext(AppearanceContext);
  const typeContext = useContext(TypeContext);
  const disabledContext = useContext(DisabledContext);
  return /* @__PURE__ */ jsx(
    InternalUseOnlyInput,
    {
      "aria-describedby": ariaDescribedBy ? ariaDescribedBy : describedByContext,
      id: id ? id : idContext,
      $small: small ? small : smallContext,
      disabled: disabled ? disabled : disabledContext,
      type: typeContext ?? type,
      $validityState: validityStateContext,
      $curAppearanceContext: curAppearanceContext,
      ...props,
      ref
    }
  );
};
var Input = forwardRef(InputComponent);
Input.displayName = "Input";
Input.isInput = true;
var Input_default = Input;
export {
  InternalUseOnlyInput,
  Input_default as default
};
